<template>
  <div>
    <div class="input-group" style="width: 170px;">
      <input ref="datepicker" type="text" class="form-control form_datetime_time_only no-focus" :disabled="layoutData.disabled === true" :class="{'is-invalid': layoutData.errorText != null}" :value="valueData" />
      <span class="input-group-btn" @click="open">
        <button class="btn default" type="button">
          <i class="fa fa-calendar-o"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "timesheet-field-time",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        default: null
      },
      index: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        layoutData: this.layout,
        valueData: this.value
      }
    },
    watch: {
      value(newval) {
        this.valueData = newval;
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type
      },
      fieldLabel() {
        return this.layoutData.label
      }
    },
    mounted () {
      $(this.$refs.datepicker).datepicker({
        rtl: App.isRTL(),
        orientation: "bottom right",
        autoclose: true,
        format: "yyyy-mm-dd"
      }).on("change", (e) => {
        this.valueData = e.target.value;
        this.onChange(e);
      });
    },
    methods: {
      onChange(e) {
        this.$emit("change", e, this.layoutData, this.valueData, this.index);
      },
      open() {
        $(this.$refs.datepicker).datepicker("show");
      }
    },
  }
</script>

<style lang="scss">
.datetimepicker-hours, .datetimepicker-minutes {
  &>table>thead {
    display: none;
  }
  &>table>tbody>tr>td {
    width: 202px;
  }
  & .hour {
    width: 44px;
    display: inline-block;
  }
}
</style>